module.exports = __webpack_public_path__ + "static/salesforce_create_webhook-f2dfe052a66e08ae5c725d7bae8e3155.png";